const baseTabStyles = {
  tab: {
    backgroundColor: 'white',
    color: 'black',
  },
  activeTab: {
    backgroundColor: 'rgb(103, 58, 183)',
    color: 'white',
  },
  underline: {
    height: '4px',
    marginTop: '-4px',
    backgroundColor: 'unset',
  },
}

const topsTabStyles = {
  ...baseTabStyles,
  activeTab: {
    backgroundColor: '#e72da1',
  },
  underline: {
    backgroundColor: 'white',
  },
}

const tabStyles = isTops => (isTops ? topsTabStyles : baseTabStyles)

export default tabStyles



// WEBPACK FOOTER //
// ./src/components/Settings/styles/Tabs.js